const BE = {
  '613200a': {
    EN: 'Accounting fees 🔺',
    FR: 'Frais de comptabilité 🔺',
    NL: 'Boekhoudkundige kosten 🔺',
    DE: 'Buchhaltungskosten 🔺',
  },
  618000: {
    EN: 'Director compensation 💵',
    FR: 'Rémunération dirigeant 💵',
    NL: 'Vergoeding zaakvoerder 💵',
    DE: 'Geschäftsführergehälter 💵',
  },
  615400: {
    EN: 'Advertising 📣',
    FR: 'Publicité 📣',
    NL: 'Publiciteit 📣',
    DE: 'Werbung 📣',
  },
  659000: {
    EN: 'Bank & interests',
    FR: 'Frais bancaires et intérêts',
    NL: 'Bank & interesten',
    DE: 'Bankgebühren & Zinsen',
  },
  613403: {
    EN: 'Bike 🚲   - Leasing or rental',
    FR: 'Vélo 🚲 - Location ou leasing',
    NL: 'Fiets 🚲  - Huur of leasing',
    DE: 'Fahrrad 🚲 - Leasing oder Miete',
  },
  613413: {
    EN: 'Bike 🚲   - Maintenance',
    FR: 'Bike 🚲 - Entretien',
    NL: 'Fiets 🚲  - Onderhoud',
    DE: 'Fahrrad 🚲 - Instandhaltung',
  },
  613702: {
    EN: 'Bike 🚲   - Purchase',
    FR: 'Bike 🚲 - Achat',
    NL: 'Fiets 🚲  - Aankoop',
    DE: 'Fahrrad 🚲 - Kauf',
  },
  613416: {
    EN: 'Bike 🚲   - Parts/accessories',
    FR: 'Bike 🚲   - Pièces/accessoires',
    NL: 'Fiets 🚲  - Onderdelen of accessoires',
    DE: '',
  },
  222000: {
    EN: 'Built land 🏔',
    FR: 'Terrain 🏔',
    NL: 'Terreinen 🏔',
    DE: 'Bebaute Grundstücke 🏔',
  },
  '615300a': {
    EN: 'Business gifts 🎁',
    FR: "Cadeaux d'affaires 🎁",
    NL: 'Relatiegeschenken 🎁',
    DE: 'Geschenke  🎁',
  },
  '6450a': {
    EN: 'Car 🚗  - Fines',
    FR: 'Voiture 🚗 - Amendes',
    NL: 'Auto 🚗  - Boetes',
    DE: 'Auto 🚗 - Bußgelder',
  },
  613420: {
    EN: 'Car 🚗  - Fuel & electricity',
    FR: 'Voiture 🚗 - Carburant',
    NL: 'Auto 🚗  - Brandstof & elektriciteit',
    DE: 'Auto 🚗 - Kraftstoff und Strom',
  },
  613530: {
    EN: 'Car 🚗  - Insurance',
    FR: 'Voiture 🚗 - Assurance',
    NL: 'Auto 🚗  - Verzekeringen',
    DE: 'Auto 🚗 - Versicherung',
  },
  613400: {
    EN: 'Car 🚗  - Leasing/rental',
    FR: 'Voiture 🚗 - Leasing / Location',
    NL: 'Auto 🚗  - Leasing/huur',
    DE: 'Auto 🚗 - Leasing/Miete',
  },
  613410: {
    EN: 'Car 🚗  - Maintenance',
    FR: 'Voiture 🚗 - Maintenance',
    NL: 'Auto 🚗  - Onderhoud',
    DE: 'Auto 🚗 - Wartung',
  },
  613430: {
    EN: 'Car 🚗  - Parking',
    FR: 'Voiture 🚗 - Parking',
    NL: 'Auto 🚗  - Parking',
    DE: 'Auto 🚗 - Parken',
  },
  '613430a': {
    EN: 'Car 🚗  - Parking',
    FR: 'Voiture 🚗 - Parking',
    NL: 'Auto 🚗  - Parking',
    DE: 'Auto 🚗 - Parken',
  },
  241000: {
    EN: 'Car 🚗  - Purchase',
    FR: 'Voiture 🚗 - Achat',
    NL: 'Auto 🚗  - Aankoop',
    DE: 'Auto 🚗 - Erwerb',
  },
  613425: {
    EN: 'Car 🚗  - Parts/accessories',
    FR: 'Voiture 🚗 - Pièces/accessoires',
    NL: 'Auto 🚗  - Onderdelen of accessoires',
    DE: '',
  },
  640000: {
    EN: 'Car 🚗  - Taxes',
    FR: 'Voiture 🚗 - Taxes',
    NL: 'Auto 🚗  - Belastingen',
    DE: 'Auto 🚗 - Steuern',
  },
  6130: {
    EN: 'Clubs & associations 🤝',
    FR: 'Clubs & Associations 🤝',
    NL: 'Clubs & verenigingen',
    DE: 'Vereine und Verbände 🤝',
  },
  '240200a': {
    EN: 'Computer/phone purchase 🖥',
    FR: 'Achat informatique 🖥',
    NL: 'Aankoop computer/telefoon 🖥',
    DE: 'Ankauf Computers/Telefons 🖥',
  },
  '240200b': {
    EN: 'Computer/phone purchase 🖥',
    FR: 'Achat informatique 🖥',
    NL: 'Aankoop computer/telefoon 🖥',
    DE: 'Ankauf Computers/Telefons 🖥',
  },
  6140: {
    EN: 'Conferences 📚',
    FR: 'Conférences 📚',
    NL: 'Conferenties 📚',
    DE: 'Konferenzen 📚',
  },
  221000: {
    EN: 'Construction 🏔',
    FR: 'Construction 🏔',
    NL: 'Bouwontwikkeling 🏔',
    DE: 'Bauwesen 🏔',
  },
  613404: {
    EN: 'eBike 🚲   - Leasing or rental',
    FR: 'ebike 🚲 - Location ou leasing',
    NL: 'e-bike 🚲  - Leasing of huur',
    DE: 'eBike 🚲 - Leasing oder Miete',
  },
  613414: {
    EN: 'eBike 🚲   - Maintenance',
    FR: 'ebike 🚲 - Entretien',
    NL: 'e-bike 🚲  - Onderhoud',
    DE: 'eBike 🚲 - Instandhaltung',
  },
  613703: {
    EN: 'eBike 🚲   - Purchase',
    FR: 'ebike 🚲 - Achat',
    NL: 'e-bike 🚲  - Aankoop',
    DE: 'eBike 🚲 - Erwerb',
  },
  613417: {
    EN: 'eBike 🚲   - Parts/accessories',
    FR: 'ebike 🚲 - Pièces/accessoires',
    NL: 'e-bike 🚲  - Onderdelen of accessoires',
    DE: '',
  },
  '613310a': {
    EN: 'Flights ✈️',
    FR: 'Vols ✈️',
    NL: 'Vluchten ✈️',
    DE: 'Flüge ✈️',
  },
  604000: {
    EN: 'Goods for resale 🔀',
    FR: 'Biens pour la revente 🔀',
    NL: 'Aankopen van handelsgoederen 🔀',
    DE: 'Waren zum Weiterverkauf 🔀',
  },
  613320: {
    EN: 'Hotels 🏨',
    FR: 'Hôtels 🏨',
    NL: 'Hotels 🏨',
    DE: 'Hotels 🏨',
  },
  230000: {
    EN: 'Installation 🏗',
    FR: 'Installation 🏗',
    NL: 'Voorzieningen 🏗',
    DE: 'Installationen 🏗',
  },
  613540: {
    EN: 'Insurance ☔️',
    FR: 'Assurance ☔️',
    NL: 'Verzekeringen ☔️',
    DE: 'Versicherung ☔️',
  },
  220000: {
    EN: 'Land 🏔',
    FR: 'Terrain 🏔',
    NL: 'Terrein 🏔',
    DE: 'Grund & Boden 🏔',
  },
  '615300b': {
    EN: 'Large gifts 🎁',
    FR: 'Grands cadeaux 🎁',
    NL: 'Grote geschenken 🎁',
    DE: 'Große Geschenke 🎁',
  },
  '613200b': {
    EN: 'Legal fees ⚖️',
    FR: 'Frais de justice ⚖️',
    NL: 'Juridische kosten ⚖️',
    DE: 'Rechtskosten ⚖️',
  },
  618040: {
    EN: 'Lunch vouchers 🍝',
    FR: 'Lunch vouchers 🍝',
    NL: 'Maaltijdcheques 🍝',
    DE: 'Essensgutscheine 🍝',
  },
  231000: {
    EN: 'Machines 🏗',
    FR: 'Machines 🏗',
    NL: 'Machines 🏗',
    DE: 'Maschinen 🏗',
  },
  '6450b': {
    EN: 'Moto/bike 🚲   - Fines',
    FR: 'Moto / vélo 🚲 - Amendes',
    NL: 'Motor/fiets 🚲   - Boetes',
    DE: 'Motorad 🚲 - Geldstrafen',
  },
  613401: {
    EN: 'Moto/bike 🚲   - Leasing/rental',
    FR: 'Moto / vélo 🚲 - Location',
    NL: 'Motor/fiets 🚲   - Leasing/huur',
    DE: 'Motorad 🚲 - Leasing/Verleih',
  },
  613411: {
    EN: 'Moto/bike 🚲   - Maintenance',
    FR: 'Moto / vélo 🚲 - Maintenance',
    NL: 'Motor/fiets 🚲   - Onderhoud',
    DE: 'Motorad 🚲 - Wartung',
  },
  241220: {
    EN: 'Moto/bike 🚲   - Purchase',
    FR: 'Moto / vélo 🚲 - Achat',
    NL: 'Motor/fiets 🚲   - Aankoop',
    DE: 'Motorad 🚲 - Erwerb',
  },
  613531: {
    EN: 'Moto/bike 🚲  - Insurance',
    FR: 'Moto / vélo 🚲 - Assurance',
    NL: 'Motor/fiets 🚲   - Verzekering',
    DE: 'Motorad 🚲 - Versicherung',
  },
  613431: {
    EN: 'Moto/bike 🚲  - Parking',
    FR: 'Moto / vélo 🚲 - Parking',
    NL: 'Motor/fiets 🚲   - Parking',
    DE: 'Motorad 🚲 - Parkplatz',
  },
  '613431a': {
    EN: 'Moto/bike 🚲  - Parking',
    FR: 'Moto / vélo 🚲 - Parking',
    NL: 'Motor/fiets 🚲   - Parking',
    DE: 'Motorad 🚲 - Parkplatz',
  },
  640001: {
    EN: 'Moto/bike 🚲  - Taxes',
    FR: 'Moto / vélo 🚲 - Taxes',
    NL: 'Motor/fiets 🚲   - Belastingen',
    DE: 'Motorad 🚲 - Steuern',
  },
  613435: {
    EN: 'Moto/bike 🚲  - Parts/accessories',
    FR: 'Moto/bike 🚲  -  Pièces/accessoires',
    NL: 'Moto/bike 🚲  - Onderdelen of accessoires',
    DE: '',
  },
  613421: {
    EN: 'Moto/bike 🚲 - Fuel & electricity',
    FR: 'Moto / vélo 🚲 - Carburant',
    NL: 'Motor/fiets 🚲   - Brandstof & elektriciteit',
    DE: 'Motorad 🚲 - Kraftstoff und Strom',
  },
  612400: {
    EN: 'Office & admin fees 📎',
    FR: 'Frais de bureau 📎',
    NL: 'Kantoor- en administratiekosten 📎',
    DE: 'Büro- und Verwaltungskosten 📎',
  },
  '610000a': {
    EN: 'Office & rent 💼',
    FR: 'Bureau & loyer 💼',
    NL: 'Kantoor & huur 💼',
    DE: 'Büro & Miete 💼',
  },
  '610000b': {
    EN: 'Office & rent 💼',
    FR: 'Bureau & loyer 💼',
    NL: 'Kantoor & huur 💼',
    DE: 'Büro & Miete 💼',
  },
  240000: {
    EN: 'Office furniture 🛋',
    FR: 'Meubles 🛋',
    NL: 'Kantoormeubels 🛋',
    DE: 'Büromöbel 🛋',
  },
  '613200c': {
    EN: 'Other legal fees ⚖️',
    FR: 'Autres frais juridiques ⚖️',
    NL: 'Andere juridische kosten ⚖️',
    DE: 'Sonstige Anwaltskosten ⚖️',
  },
  623000: {
    EN: 'Other personnel cost 💵',
    FR: 'Autre frais de personnel 💵',
    NL: 'Andere personeelskosten 💵',
    DE: 'Sonstige Personalkosten 💵',
  },
  '613310b': {
    EN: 'Other travel fees 🌄',
    FR: 'Autres frais de voyage 🌄',
    NL: 'Andere reiskosten 🌄',
    DE: 'Sonstige Reisekosten 🌄',
  },
  618030: {
    EN: 'Pension 👵🏻',
    FR: 'Pension 👵🏻',
    NL: 'Pensioen 👵🏻',
    DE: 'Rente 👵🏻',
  },
  624000: {
    EN: 'Pension 👵🏻',
    FR: 'Pension 👵🏻',
    NL: 'Pensioen 👵🏻',
    DE: 'Rente 👵🏻',
  },
  613330: {
    EN: 'Per diems 🍝',
    FR: 'Per diems 🍝',
    NL: 'Dagvergoedingen 🍝',
    DE: 'Per diems 🍝',
  },
  620500: {
    EN: 'Personnel cost 💵',
    FR: 'Coût du personnel 💵',
    NL: 'Personeelskosten 💵',
    DE: 'Personalkosten 💵',
  },
  615500: {
    EN: 'Prof. contributions 💰',
    FR: 'Contributions prof. 💰',
    NL: 'Prof. bijdragen💰',
    DE: 'Beiträge 💰',
  },
  223000: {
    EN: 'Property rights 🏔',
    FR: 'Droits de propriété 🏔',
    NL: 'Eigendomsrechten 🏔',
    DE: 'Eigentumsrechte 🏔',
  },
  613350: {
    EN: 'Public transport 🚃',
    FR: 'Transport public 🚃',
    NL: 'Openbaar vervoer 🚃',
    DE: 'Öffentlicher Verkehr 🚃',
  },
  '613350a': {
    EN: 'Public transport 🚃',
    FR: 'Transport public 🚃',
    NL: 'Openbaar vervoer 🚃',
    DE: 'Öffentlicher Verkehr 🚃',
  },
  600000: {
    EN: 'Raw materials 🌾',
    FR: 'Matières premières 🌾',
    NL: 'Grondstoffen 🌾',
    DE: 'Rohmaterialien 🌾',
  },
  618020: {
    EN: 'Social contributions 💰',
    FR: 'Contributions sociales 💰',
    NL: 'Sociale bijdragen 💰',
    DE: 'Sozialbeiträge 💰',
  },
  602000: {
    EN: 'Studies & works 📐',
    FR: 'Études et travaux 📐',
    NL: 'Studies & werken 📐',
    DE: 'Weiterbildung 📐',
  },
  603000: {
    EN: 'Subcontractors 😏',
    FR: 'Sous-traitants 😏',
    NL: 'Onderaanneming 😏',
    DE: 'Unterauftragnehmer 😏',
  },
  613340: { EN: 'Taxi 🚕', FR: 'Taxi 🚕', NL: 'Taxi 🚕', DE: 'Taxi 🚕' },
  '240200c': {
    EN: 'Tech purchase 🖥',
    FR: 'Achat Tech 🖥',
    NL: 'Technologische aankopen  🖥',
    DE: 'IT 🖥',
  },
  601000: {
    EN: 'Tools 🛠',
    FR: 'Outils 🛠',
    NL: 'Materiaal 🛠',
    DE: 'Werkzeug 🛠',
  },
  '613600a': {
    EN: 'Training food 📚',
    FR: 'Formations (nourriture)',
    NL: 'Opleidingen (met eten) 📚',
    DE: 'Verpflegung bei Schulungen 📚',
  },
  '613600b': {
    EN: 'Trainings 📚',
    FR: 'Formations 📚',
    NL: 'Opleidingen 📚',
    DE: 'Schulungen 📚',
  },
  '6450c': {
    EN: 'Utility 🚚   - Fines',
    FR: 'Utilitaire 🚚 - Amendes',
    NL: 'Bedrijfswagen 🚚 - Boetes',
    DE: 'Berufswagen 🚚 - Geldbußen',
  },
  613402: {
    EN: 'Utility 🚚   - Leasing/rental',
    FR: 'Utilitaire 🚚 - Location / Leasing',
    NL: 'Bedrijfswagen 🚚 - Leasing/huur',
    DE: 'Berufswagen 🚚 - Leasing/Verleih',
  },
  613412: {
    EN: 'Utility 🚚   - Maintenance',
    FR: 'Utilitaire 🚚 - Maintenance',
    NL: 'Bedrijfswagen 🚚 - Onderhoud',
    DE: 'Berufswagen 🚚 - Wartung',
  },
  613422: {
    EN: 'Utility 🚚  - Fuel & electricity',
    FR: 'Utilitaire 🚚 - Carburant',
    NL: 'Bedrijfswagen 🚚 - Brandstof & elektriciteit',
    DE: 'Berufswagen 🚚 - Kraftstoff und Strom',
  },
  613532: {
    EN: 'Utility 🚚  - Insurance',
    FR: 'Utilitaire 🚚 - Assurance',
    NL: 'Bedrijfswagen 🚚 - Verzekering',
    DE: 'Berufswagen 🚚 - Versicherung',
  },
  613432: {
    EN: 'Utility 🚚  - Parking',
    FR: 'Utilitaire 🚚 - Parking',
    NL: 'Bedrijfswagen 🚚 - Parking',
    DE: 'Berufswagen 🚚 - Parkplatz',
  },
  '613432a': {
    EN: 'Utility 🚚  - Parking',
    FR: 'Utilitaire 🚚 - Parking',
    NL: 'Bedrijfswagen 🚚 - Parking',
    DE: 'Berufswagen 🚚 - Parkplatz',
  },
  241100: {
    EN: 'Utility 🚚  - Purchase',
    FR: 'Utilitaire 🚚 - Achat',
    NL: 'Bedrijfswagen 🚚 - Aankoop',
    DE: 'Berufswagen 🚚 - Erwerb',
  },
  640002: {
    EN: 'Utility 🚚  - Taxes',
    FR: 'Utilitaire 🚚 - Taxes',
    NL: 'Bedrijfswagen 🚚 - Belastingen',
    DE: 'Berufswagen 🚚 - Steuern',
  },
  613415: {
    EN: 'Utility 🚚  - Parts/accessories',
    FR: 'Utility 🚚  - Pièces/accessoires',
    NL: 'Utility 🚚  - Onderdelen of accessoires',
    DE: '',
  },
  '612200a': {
    EN: 'Workplace - decoration 🖼',
    FR: 'Bureau - Décoration 🖼',
    NL: 'Werkplek - Decoratie 🖼',
    DE: 'Arbeitsplatz - Dekoration 🖼',
  },
  '612200b': {
    EN: 'Workplace - decoration 🖼',
    FR: 'Bureau - Décoration 🖼',
    NL: 'Werkplek - Decoratie 🖼',
    DE: 'Arbeitsplatz - Dekoration 🖼',
  },
  '612200c': {
    EN: 'Workplace - maintenance 🧽',
    FR: 'Bureau - Entretien 🧽',
    NL: 'Werkplek - Onderhoud 🧽',
    DE: 'Arbeitsplatz - Wartung 🧽',
  },
  '612200d': {
    EN: 'Workplace - maintenance 🧽',
    FR: 'Bureau - Entretien 🧽',
    NL: 'Werkplek - Onderhoud 🧽',
    DE: 'Arbeitsplatz - Wartung 🧽',
  },
  '612200e': {
    EN: 'Workplace - maintenance 🧽',
    FR: 'Bureau - Entretien 🧽',
    NL: 'Werkplek - Onderhoud 🧽',
    DE: 'Arbeitsplatz - Wartung 🧽',
  },
  '612200f': {
    EN: 'Workplace - maintenance 🧽',
    FR: 'Bureau - Entretien 🧽',
    NL: 'Werkplek - Onderhoud 🧽',
    DE: 'Arbeitsplatz - Wartung 🧽',
  },
  610100: {
    EN: 'Workplace - utilities 🔌',
    FR: 'Bureau - Elec & eau 🔌',
    NL: 'Werkplek - Electriciteit & water 🔌',
    DE: 'Arbeitsplatz - Versorgungsunternehmen 🔌',
  },
  610110: {
    EN: 'Workplace - utilities 🔌',
    FR: 'Bureau - Elec & eau 🔌',
    NL: 'Werkplek - Electriciteit & water 🔌',
    DE: 'Arbeitsplatz - Versorgungsunternehmen 🔌',
  },
};

export default BE;
